<template>
    <div v-if="info.bg_image" class="floor-bgImg">
        <el-image style="width: 100%;height: 100%;" :src="$img(info.bg_image)" fit="fill"></el-image>
    </div>
</template>

<script>
export default {
    name: "floor-bgImg",
    components: {},
    props: {
        info: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {}
    },
    created() {},
    mounted() {
    },
    computed: {
        
    },
    methods: {}
}
</script>

<style lang="scss">
    .floor-bgImg{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
</style>
